import { render } from "./ModelVersionsTable.vue?vue&type=template&id=66242e10"
import script from "./ModelVersionsTable.vue?vue&type=script&lang=js"
export * from "./ModelVersionsTable.vue?vue&type=script&lang=js"

import "./ModelVersionsTable.vue?vue&type=style&index=0&id=66242e10&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__